import { __assign } from "tslib";
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { View, Platform } from 'react-native';
import { PnmacCard, PnmacCardTitle, PnmacCardContent, PnmacImage, PnmacModal, PnmacParagraph, PnmacUIButton, PnmacText, PnmacCardActions, PnmacHtmlToNative, PnmacNavigation } from 'pnmac-universal-components';
import SimplyIOAPopups from './Popups/SimplyIOA.js';
import styless from '../styles/styles.js';
import { UserLanguage_ENUM, TrackerHitTypeLID_ENUM, TrackerCategoryLID_ENUM } from '../redux/events/events.js';
var SimplyIOATile = function (props) {
  var _a;
  var _b = useState(false),
    open = _b[0],
    setOpen = _b[1];
  var _c = useState(null),
    simplyIOAData = _c[0],
    setSimplyIOAData = _c[1];
  var _d = useState(false),
    isMounted = _d[0],
    setIsMounted = _d[1];
  useEffect(function () {
    if (props.layout && props.layout.simplyIOAData && !isMounted) {
      setSimplyIOAData(props.layout.simplyIOAData);
      setIsMounted(true);
    }
  }, [props.layout, isMounted]);
  useEffect(function () {
    if (open && props.layout.isUserIdle) {
      setOpen(false);
      addTrackerAndLampNotes(5);
    }
  }, [props.layout.isUserIdle]);
  /*write tracker events and lamp notes
  params: @type
  1 = tile button clicked
  2 = Interstitial page displayed
  3 = `Back to PennyMac` button clicked
  4 = `Continue to SimplyIOA` button clicked
  5 = tab auto close
  */
  var addTrackerAndLampNotes = function (type) {
    var isEscrow = props.isEscrow;
    var escrowText = isEscrow ? "Escrow" : "Pennyhome";
    var getTrackerLabel = function () {
      switch (type) {
        case 1:
          return "Simplyioa/" + escrowText;
        case 2:
          return "Simplyioa/modal from " + escrowText;
        case 3:
          return "Simplyioa/modal from " + escrowText + " clicked Back";
        case 4:
          return "Simplyioa/modal from " + escrowText + " clicked Continue";
        case 5:
          return "Simplyioa/tab closed";
      }
    };
    var trackerText = getTrackerLabel();
    if (Platform.OS === "ios" || Platform.OS === "android") {
      props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, trackerText + "|Mobile", -1, "", false);
    } else {
      props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Page, TrackerHitTypeLID_ENUM.PageView, TrackerHitTypeLID_ENUM.PageView, trackerText + "|Web", 0);
    }
    if (type != 2) {
      var lampNoteEscrowText = isEscrow ? "Escrow page" : "Pennyhome page";
      var getLampNotes = function () {
        switch (type) {
          case 1:
            return {
              message: "initiated a SimplyIOA quote from ",
              eventTypeLId: 1000169
            };
          case 3:
            return {
              message: "navigated back to ",
              eventTypeLId: 1000170
            };
          case 4:
            return {
              message: "Continued to SimplyIOA to get a quote from ",
              eventTypeLId: 1000171
            };
          case 5:
            return {
              message: "SimplyIOA page closed due to inactivity",
              eventTypeLId: 1000172
            };
        }
      };
      var lampNotes = getLampNotes().message + (type !== 5 ? lampNoteEscrowText : "");
      addLampNotes(lampNotes, getLampNotes().eventTypeLId);
    }
  };
  var addLampNotes = function (message, eventTypeLId) {
    var _a;
    var data = {
      LoanId: (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.loanId,
      EventTypeId: eventTypeLId,
      Message: message
    };
    fetch("".concat(props.layout.pennyHomeUrl, "api/simplyIOA/addLampNotes"), {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        "Authorization": "Bearer ".concat(layout.token)
      },
      body: JSON.stringify(data)
    }).then(function (s) {
      if (s.ok) {}
    }).catch(function (err) {});
  };
  var translations = props.translations,
    layout = props.layout,
    matches = props.matches,
    styles = props.styles,
    maxHeight = props.maxHeight,
    minHeight = props.minHeight,
    addDisposition = props.addDisposition;
  var isPennyWise = layout.pennyWise;
  var customizeUI = function (scriptNumber) {
    switch (scriptNumber) {
      case 1:
        return [translations === null || translations === void 0 ? void 0 : translations.SimplyIOAHeadertextN, translations === null || translations === void 0 ? void 0 : translations.SimplyIOABodytextN, translations === null || translations === void 0 ? void 0 : translations.SimplyIOAbuttonN];
      case 2:
        return [translations === null || translations === void 0 ? void 0 : translations.SimplyIOAHeadertextX, translations === null || translations === void 0 ? void 0 : translations.SimplyIOABodytextX, translations === null || translations === void 0 ? void 0 : translations.SimplyIOAbuttonX];
      case 3:
        return [translations === null || translations === void 0 ? void 0 : translations.SimplyIOAHeadertextY, translations === null || translations === void 0 ? void 0 : translations.SimplyIOABodytextY, translations === null || translations === void 0 ? void 0 : translations.SimplyIOAbuttonY];
      case 4:
        return [translations === null || translations === void 0 ? void 0 : translations.SimplyIOAHeadertextZ, translations === null || translations === void 0 ? void 0 : translations.SimplyIOABodytextZ, translations === null || translations === void 0 ? void 0 : translations.SimplyIOAbuttonZ];
      default:
        return [translations === null || translations === void 0 ? void 0 : translations.SimplyIOAHeadertextN, translations === null || translations === void 0 ? void 0 : translations.SimplyIOABodytextN, translations === null || translations === void 0 ? void 0 : translations.SimplyIOAbuttonN];
    }
  };
  var _e = customizeUI((_a = layout === null || layout === void 0 ? void 0 : layout.simplyIOAData) === null || _a === void 0 ? void 0 : _a.scriptNumber),
    tileHeader = _e[0],
    tileBody = _e[1],
    buttonTitle = _e[2];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    id: "simplyIOATile",
    style: styles
  }, /*#__PURE__*/React.createElement(PnmacCard, {
    nativeID: "cdSimplyIOAOffer",
    elvation: 0,
    style: __assign(__assign({}, styless.card.innerStyle), {
      paddingLeft: 0,
      minHeight: minHeight,
      maxHeight: maxHeight
    })
  }, /*#__PURE__*/React.createElement(PnmacCardTitle, {
    titleStyle: {
      fontWeight: "bold",
      fontSize: !matches.small ? 22 : 20,
      height: !matches.small ? 'auto' : 'auto'
    },
    title: tileHeader,
    titleNumberOfLines: 4,
    right: function () {
      return PnmacImage(layout.mobile ? "simplyIoa" : require("../assets/simply-ioa.svg"), matches.small ? 40 : 50, "SimplyIOA", 'css');
    }
  }), /*#__PURE__*/React.createElement(PnmacCardContent, {
    style: {
      display: "flex",
      flexDirection: "column",
      marginBottom: 20
    }
  }, /*#__PURE__*/React.createElement(PnmacParagraph, {
    style: {
      marginTop: 20,
      marginBottom: 10
    }
  }, tileBody), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    fontFamily: 'Open Sans',
    value: translations === null || translations === void 0 ? void 0 : translations.SimplyIOAcalltoaction
  }), /*#__PURE__*/React.createElement(PnmacCardActions, {
    style: {
      alignItems: "center",
      justifyContent: "center",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PnmacUIButton, {
    hoverColor: "#cce9f5",
    disabled: layout.pennyWise,
    uppercase: true,
    iconSize: 30,
    iconStyles: {
      marginLeft: 5
    },
    style: {
      width: '100%',
      margin: 5,
      backgroundColor: "#fff",
      shadowColor: 'white',
      borderWidth: 1,
      borderColor: '#003087',
      alignItems: 'flex-start',
      borderRadius: 6
    },
    onPress: function () {
      addTrackerAndLampNotes(1);
      PnmacNavigation(__assign({
        action: simplyIOAData === null || simplyIOAData === void 0 ? void 0 : simplyIOAData.quoteUrl,
        wind: true,
        target: "_blank"
      }, props));
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      fontFamily: "Montserrat",
      fontWeight: "bold",
      textTransform: 'uppercase',
      textAlign: 'center',
      paddingHorizontal: 5
    },
    idTag: "btnClaimBlog"
  }, buttonTitle), PnmacImage(layout.mobile ? "caretRight" : require("../assets/caret-right.svg"), 25, "Blog CaretRight icon", 'xml'))), /*#__PURE__*/React.createElement(PnmacText, {
    style: {
      textAlign: 'center',
      fontStyle: 'italic'
    }
  }, translations === null || translations === void 0 ? void 0 : translations.SimplyIOANavigationText)))), /*#__PURE__*/React.createElement(PnmacModal, {
    open: open
  }, /*#__PURE__*/React.createElement(SimplyIOAPopups, {
    addTracker: function (data) {
      return addTrackerAndLampNotes(data);
    },
    modalClose: function () {
      setOpen(false);
    },
    matches: matches,
    simplyIOAData: simplyIOAData,
    open: open,
    layout: layout,
    translations: translations,
    navigation: props.navigation
  })));
};
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(SimplyIOATile);